var map = {
	"./temp-diary.svg": "b427",
	"./temp-notes.svg": "dc1a",
	"./temp-novel.svg": "ef77",
	"./temp-postIt.svg": "b1ce",
	"./temp-share.svg": "6059",
	"./temp-storage.svg": "83e2",
	"./temp-todo.svg": "bfb4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a31";